import createState from "./state";
import { FREIGHT_TABLE_STATUS_LABEL } from "../constants/freightTableStatus";

export const RESET_LIST_STATE = (state) => {
  const fresh = createState();
  state.items = fresh.items;
  state.pagination = fresh.pagination;
  state.filters = fresh.filters;
  state.counts = fresh.counts;
  state.loading = fresh.loading;
  state.error = fresh.error;
};

export const RESET_DETAILS_STATE = (state) => {
  const fresh = createState();
  state.details = fresh.details;
  state.detailsLoading = fresh.detailsLoading;
  state.carriers = fresh.carriers;
  state.carriersPagination = fresh.carriersPagination;
  state.carriersFilters = fresh.carriersFilters;
  state.carriersLoading = fresh.carriersLoading;
  state.routes = fresh.routes;
  state.routesLoading = fresh.routesLoading;
  state.routesFilters = fresh.routesFilters;
};

export const SET_LOADING = (state, loading) => {
  state.loading = loading;
};

export const SET_FREIGHT_TABLES = (state, { items, pagination }) => {
  state.items = items;
  state.pagination = pagination;
};

export const SET_FILTERS = (state, filters) => {
  state.filters = { ...state.filters, ...filters };
};

export const SET_COUNTS = (state, counts) => {
  state.counts = { ...state.counts, ...counts };
};

export const SET_ERROR = (state, error) => {
  state.error = error;
};

export const INVALIDATE_RAW_ITEM = (state, tabfreId) => {
  const id = Number(tabfreId);
  if (state.rawById[id] === undefined) return;

  const next = { ...state.rawById };
  delete next[id];
  state.rawById = next;
};

export const SET_RAW_ITEMS = (state, rawItems) => {
  const next = { ...state.rawById };
  rawItems.forEach((raw) => {
    next[raw.tabfre_id] = raw;
  });
  state.rawById = next;
};

export const SET_RAW_CARRIER_STATUS = (state, { carrierIds, status }) => {
  const ids = carrierIds.map(Number);

  Object.keys(state.rawById).forEach((key) => {
    const raw = state.rawById[key];
    const carriers =
      raw.TabelaFreteTransportador || raw.tabela_frete_transportador || [];

    carriers.forEach((carrier) => {
      if (ids.indexOf(Number(carrier.tabfretransp_id)) === -1) return;
      carrier.status = status;
      // O descr da relação tem precedência no statusPair: sem trocá-lo junto, o
      // badge continuaria escrito "Ativo" pintado de inativo até um F5.
      if (carrier.Status) {
        carrier.Status = {
          ...carrier.Status,
          valor: status,
          descr: FREIGHT_TABLE_STATUS_LABEL[status] || "",
        };
      }
    });
  });
};

export const SET_DETAILS_LOADING = (state, loading) => {
  state.detailsLoading = loading;
};

export const SET_DETAILS = (state, details) => {
  state.details = details;
};

export const SET_CARRIERS_LOADING = (state, loading) => {
  state.carriersLoading = loading;
};

export const SET_CARRIERS = (state, { items, pagination }) => {
  state.carriers = items;
  state.carriersPagination = pagination;
};

export const SET_CARRIERS_FILTERS = (state, filters) => {
  state.carriersFilters = { ...state.carriersFilters, ...filters };
};

export const SET_ROUTES_LOADING = (state, loading) => {
  state.routesLoading = loading;
};

export const SET_ROUTES = (state, routes) => {
  state.routes = routes;
};

export const SET_ROUTES_FILTERS = (state, filters) => {
  state.routesFilters = { ...state.routesFilters, ...filters };
};

export const SET_OPTIONS = (state, options) => {
  state.options = options;
};

export const SET_OPTIONS_LOADING = (state, loading) => {
  state.optionsLoading = loading;
};

export const SET_ITINERARY_OPTIONS = (state, options) => {
  state.itineraryOptions = options;
};

export const SET_ITINERARY_OPTIONS_LOADING = (state, loading) => {
  state.itineraryOptionsLoading = loading;
};

export const SET_CARRIER_STATUS = (state, { carrierId, status, statusValor }) => {
  state.carriers = state.carriers.map(function (carrier) {
    if (carrier.carrierId !== carrierId) return carrier;
    return { ...carrier, status, statusValor };
  });
};
